import React, { useState, Component } from 'react';
import styled from "styled-components"
import { render } from 'react-dom';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import iconImg from '../../../../assets/imgs/edit.svg';

import CalenderIcon from '../../../../assets/imgs/calendar-icon.png'

var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var date = new Date();
var tomorrow = new Date(date.getFullYear(), date.getMonth(), (date.getDate() + 1));


class DateTimePicker extends Component {

  constructor(props){
    super(props);
    this.state = {
      startDate: '',
      stateDateVar: false,
      
    }
   
}

  componentDidMount(){

    document.querySelectorAll(".datePickerSubmitButton").forEach(element=>{
      element.classList.add("disabled")
    })
  }
  


  handleChange = date => {

   // if(date.substr(16, 5))

    

    
    this.setState({
      startDate: date
    });

    if(String(this.state.startDate).substr(16, 5) == ''){date.setHours(9,30,0,0)}


   // console.log(this.props.isPushBotVisible);
    document.querySelectorAll(".datePickerSubmitButton").forEach(element=>{
      element.classList.remove("disabled")
    })

  };

  handleClick = () => {

    // console.log(this.state.startDate);
    let date = String(this.state.startDate);
    //****************************************** */
    let time = date.substr(16, 5);
    let timeToBackend = date.substr(16,8)
    // if(date.substr(16, 5) == "00:00"){
    //   time = "9:30";
    //   timeToBackend="09:30:00";
     
    //   this.setState({
    //     stateDateVar: true,
    //   });
    //   console.log(this.state.stateDateVar)
   
    // }else{
    //   time = date.substr(16, 5);
    //   timeToBackend = date.substr(16,8)

    //     this.setState({
    //       stateDateVar: false,
        
    //     });
    //     console.log(this.state.stateDateVar)
    // }

    // let meridiem = parseInt(date.substr(16,2));
    // if(meridiem >= 12){
    //   time = time + " PM";
    // }else{
    //   time = time + " AM";
    // }

    /*************************************************** */
    
    let month = date.substring(4,7);

    var val=months.indexOf(month)+1;
    if(val<10){
      month = '0'+val;
    }else{
      month =val; 
    }
    
    let dateToBackend = date.substring(11,15) + "-" + month + "-" + date.substring(8,10) + "T" + timeToBackend
    date = date.substring(8,10) + "-" + month + "-" + date.substring(11,15) + ", " + time;
    //2020-07-16T15:09:00 
  
//    console.log(dateToBackend);

    let inputString =   date + "<split>" + dateToBackend;
    window['autosubmit'](inputString);

  }

  render() {

    const  MainBlock=styled.div`

    height:auto;
    margin-top: 10px;

    .datepicker-div{
      position: relative;
      width: 100%;
     // transform: scale(0.9);

     // margin-left:-22px;
      z-index:10000;
      opacity: 1;//here
   
    }

    .datePickerSubmitButton{

    }

    .enabled{
      pointer-events:auto;
      opacity:1;
    }

    .icon{
      height:20px;
      width:20px;
      background: red;
    }
    

    .sf-datepicker{

      padding: 10px;
      color: #666666
      font-size:14px;
      cursor: pointer;
      width:92%;
      background: white;
      text-align:left !important;
      border: 1px solid #2c387a !important;
      border-radius: 5px !important;
      margin-bottom:5px !important;
    }

    .react-datepicker{
      font-size: 0.7em !important;
    }


    .react-datepicker-wrapper{
      width:100%
    }

    .react-datepicker-popper{
      width:330px !important;
    //  transform: translate(50px, 65px) scale(1.3) !important; //for main
      transform: ${this.props.isPushBotVisible ? 'none' : 'translate(50px, 65px) scale(1.3) !important'};

    }

    @media(max-width : 400px){
      .react-datepicker-popper{
        width:330px !important;
      //  transform: translate(13px, 63px) scale(1.3) !important; //for main
      transform: ${this.props.isPushBotVisible ? 'translate(-37px, 22px) scale(0.9) !important' : 'translate(13px, 63px) scale(1.3) !important'};
       }
    }
    `
    return (
      <MainBlock>
            {/* <div>##DateTimePicker##</div> */}
            <div className="datepicker-div">
            <DatePicker className="sf-datepicker action-elem" id="datepickerId"
              
             selected={this.state.startDate}
              onChange={this.handleChange}
              //minDate={new Date()}
              minDate = {new Date(date.getFullYear(), date.getMonth(), (date.getDate() + 1))}
             dateFormat="dd-MM-yyyy, h:mm" 
  //            dateFormat={this.state.stateDateVar?"dd-MM-yyyy, 09:30" :"dd-MM-yyyy, h:mm" 
  //  }
              autoComplete="off"
              showTimeSelect
              includeTimes={[

              //11AM-6:30pm
              new Date(date.setHours(9,30,0)), 
              new Date(date.setHours(10,0,0)), new Date(date.setHours(10,30,0)),
              new Date(date.setHours(11,0,0)), new Date(date.setHours(11,30,0)),
              new Date(date.setHours(12,0,0)), new Date(date.setHours(12,30,0)),
              new Date(date.setHours(13,0,0)), new Date(date.setHours(13,30,0)),
              new Date(date.setHours(14,0,0)), new Date(date.setHours(14,30,0)),
              new Date(date.setHours(15,0,0)), new Date(date.setHours(15,30,0)),
              new Date(date.setHours(16,0,0)), new Date(date.setHours(16,30,0)),
              new Date(date.setHours(17,0,0)), new Date(date.setHours(17,30,0)),
              new Date(date.setHours(18,0,0)), new Date(date.setHours(18,30,0)),
              // new Date(date.setHours(19,0,0)), new Date(date.setHours(19,30,0)),
              // new Date(date.setHours(20,0,0)), new Date(date.setHours(20,30,0)),
              // new Date(date.setHours(21,0,0)), new Date(date.setHours(21,30,0)),
              ]}

              placeholderText="Click to select date and time" 
              
            /></div>
          <div className="datePickerSubmitButton">
        <div className="action-elem" style={{width: "92%", marginTop: "10px"}}
          onClick={this.handleClick}>Submit</div>
          </div>


      </MainBlock>
    );
  }
} 

const ActionButton = styled.div`
    border: 0px solid #2c387a;
    border-radius: 6px;
    background: #2c387a;
    color: #fff;
    margin-top: 12px;
`



export default DateTimePicker;

